import { cn, tv } from "@utils/tw"
import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Stats",
  tags: ["#page"],
  icon: "star-filled",
  blockStyles: [
    {
      label: "2-up",
      name: "double",
      isDefault: true,
    },
    {
      label: "3-up",
      name: "triple",
    },
    {
      label: "4-up",
      name: "quad",
    },
  ],
}

export default defineBlock("content/stats", (props) => {
  const styles = gridStyles({ size: props.blockStyle || "double" })
  return (
    <div className="my-13">
      <div className={styles.base()}>
        {env.admin ? (
          <InnerBlocks
            allowedBlocks={["content/stat-item"]}
            defaultBlocks={[
              ["content/stat-item", {}],
              ["content/stat-item", {}],
            ]}
            adminClassName={styles.grid()}
          />
        ) : (
          <div className={styles.grid()}>
            <InnerBlocks />
          </div>
        )}
      </div>
    </div>
  )
})

const gridStyles = tv({
  base: "grid-auto",
  slots: {
    grid: ["col-span-12 flex flex-wrap items-stretch justify-between gap-y-grid-gutter", "[&_>_*]:w-[--item-size]"],
  },
  variants: {
    size: {
      double: "md:col-4-6 [--item-size:50%]",
      triple: "md:col-3-7 [--item-size:50%] md:[--item-size:33%]",
      quad: "md:col-1-10 [--item-size:50%] md:[--item-size:25%]",
    },
  },
})
